import type { AccumulatorsReportSchema } from '@libs/data-access/queries'
import { useQuery } from '@tanstack/react-query'
import type { UseAppQueryOptions } from 'libs/data-access/queries/src/lib/types'

import {
  type FetchAccumulatorsReportOptions,
  fetchAccumulatorsReport
} from '../accumulators.report.api'
import { accumulatorsReportCachekeys } from '../accumulators.report.cacheKeys'

export const useFetchAccumulatorsReport = (
  request: FetchAccumulatorsReportOptions,
  queryOptions?: UseAppQueryOptions<AccumulatorsReportSchema>
) => {
  return useQuery({
    ...queryOptions,
    queryKey: accumulatorsReportCachekeys.one(
      request?.pathParams.type,
      request?.queryParams?.report_id
    ),
    queryFn: () => fetchAccumulatorsReport(request),
    enabled: Boolean(request?.queryParams?.report_id)
  })
}
